import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../domain/api';

// Hook to get all Facebook accounts for the dropdown (React Query v4)
export const useSelectAllFacebookAccount = () => {
  const query = useQuery({
    queryKey: ['facebook-accounts'],
    queryFn: async () => {
      const response = await api.get('/facebook-ads/ad-accounts');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
  return [query.data || { adAccounts: [] }, query.isLoading, query.refetch];
};

// Hook to fetch a single Facebook ads report (React Query v4)
export const useSingleFacebookAdsReport = (id) => {
  const query = useQuery({
    queryKey: ['facebook-ads', id],
    queryFn: async () => {
      if (!id) return null;
      const response = await api.get(`/facebook-ads/${id}`);
      return response.data;
    },
    enabled: !!id,
  });
  return [
    {
      report_loading: query.isLoading,
      report: query.data,
      edit_report_loading: false,
    },
  ];
};

// Hook to update a Facebook ads report (React Query v4)
export const useUpdateFacebookAdsReport = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ id, data }) => {
      const response = await api.put(`/facebook-ads/${id}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['facebook-ads']);
    },
  });
  const updateData = (id, data) => mutation.mutateAsync({ id, data });
  return [updateData, { edit_report_loading: mutation.isLoading }];
};

// Hook to delete a Facebook ads report (React Query v4)
export const useDeleteFacebookAdsReport = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (id) => {
      await api.delete(`/facebook-ads/${id}`);
      return true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['facebook-ads']);
    },
  });
  const deleteReport = (id) => mutation.mutateAsync(id);
  return [deleteReport];
};
